import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    background: #121180;
    height: 70px;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export const ContainerInner = styled.div`
    width: 90%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Logo = styled.h3`
    color: #fff;
    margin: 0;
    cursor: pointer;
`;

export const Avatar = styled.img`
    width: auto;
    height: 40px;
    border-radius: 25px;
    padding-left: 10px;
`;